import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import {sortData} from "../pages/utils";
import SortAndAddNew from "./SortAndAddNew";
import DrugsAccordion from "./DrugsAccordion";

const DrugsTable = ({
                      patDrugs,
                      onDeleteDrug,
                      onAddDrug,
                      loading,
                      printView = false,
                    }) => {
  const {t} = useTranslation();
  const [showLegendModal, setShowLegendModal] = useState(false);

  const ddiLegendItems = [
    { color: "#f10909", label: t("legends_severe_ddis_and_cis") },
    { color: "#FFA500", label: t("legends_moderate_ddis") },
    { color: "#FFFFE0", label: t("legends_minor_ddis") },
    { color: "#4CAF50", label: t("legends_no_ddis_expected") },
    { color: "#627079", label: t("no_interactions") }
  ];

  const dgiLegendItems = [
    { color: "#1565a0", label: t("legends_dgis_available") },
    { color: "grey", label: t("no_interactions_found") }
  ];

  const [sortConfig, setSortConfig] = useState({
    key: "startDate",
    ascending: false,
  });

  const [sortedPatDrugs, setSortedPatDrugs] = useState(
    patDrugs ? [...patDrugs] : [],
  );

  useEffect(() => {
    const sorted = sortData(sortConfig?.key, patDrugs, sortConfig?.ascending,
        item => item[sortConfig?.key]);

    setSortedPatDrugs(sorted);
  }, [patDrugs, sortConfig]);


  return (
    <section className={`drugs-table-panel ${printView ? "drugs-table-panel--print" : ""}`}>
      {showLegendModal && (
        <div className="feedback-modal">
          <div className="feedback-modal-content medication-interactions-legend-modal">
            <header className="feedback-modal-header feedback-modal-header-right">
              <h2>{t("interaction_legend")}</h2>
              <FontAwesomeIcon
                icon={faXmark}
                className="modal-close"
                onClick={() => setShowLegendModal(false)}
              />
            </header>
            <div className="feedback-modal-body medication-interactions-legend-modal__body">
              <div className="medication-interactions-legend__grid">
                <div className="medication-interactions-legend__section">
                  <div className="medication-interactions-legend__title">{t("drug_drug_interactions")}</div>
                  <div className="medication-interactions-legend__items">
                    {ddiLegendItems.map((item) => (
                      <div key={`${item.color}-${item.label}`} className="medication-interactions-legend__item">
                        <span
                          className="medication-interactions-legend__swatch"
                          style={{ backgroundColor: item.color }}
                          aria-hidden="true"
                        />
                        <span className="medication-interactions-legend__label">{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="medication-interactions-legend__section">
                  <div className="medication-interactions-legend__title">{t("drug_gene_interactions")}</div>
                  <div className="medication-interactions-legend__items">
                    {dgiLegendItems.map((item) => (
                      <div key={`${item.color}-${item.label}`} className="medication-interactions-legend__item">
                        <span
                          className="medication-interactions-legend__swatch"
                          style={{ backgroundColor: item.color }}
                          aria-hidden="true"
                        />
                        <span className="medication-interactions-legend__label">{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <SortAndAddNew showSorting={ !printView && sortedPatDrugs?.length > 0 } sortConfig={ sortConfig }
                     onAddDrug={ onAddDrug } loading={ loading }  setSortConfig={ setSortConfig }
                     centerContent={!printView && sortedPatDrugs?.length > 0 ? (
                       <button
                         type="button"
                         className="label-link medication-interactions-legend-link"
                         onClick={() => setShowLegendModal(true)}
                       >
                         {t("interaction_legend")}
                       </button>
                     ) : null}/>
      <div className={printView ? "w3-container drugs-table-panel__content" : "w3-container drugs-content-scroll drugs-table-panel__content"}>
        { sortedPatDrugs?.length > 0
          ?
          (<div className="symptom-cards-surface drugs-accordion-surface drugs-table-panel__surface">
            <DrugsAccordion sortedPatDrugs={ sortedPatDrugs } printView={ printView } onDeleteDrug={ onDeleteDrug } />
          </div> )
          :
          (!loading && (<div className="drugs-table-panel__empty-state"><p className="w3-center"> { t("you_have_not_yet_entered_any_medication") } </p></div>) ) }
      </div>
    </section>
  );
};

export default DrugsTable;
